"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventeaStatistQueue = void 0;
const globalInstanceKey = 'eventeaStatist';
class EventeaStatistQueue {
    constructor() {
        this.instance = null;
        this.resolveInstance = () => { };
        this.instancePromise = new Promise((res) => {
            this.resolveInstance = res;
        });
        this.updateClientParameters = (...args) => {
            if (this.instance) {
                return this.instance.updateClientParameters(...args);
            }
            this.instancePromise.then((instance) => instance.updateClientParameters(...args));
        };
        const handleInstance = (statistInstance) => {
            this.instance = statistInstance;
            this.resolveInstance(statistInstance);
        };
        const instance = window[globalInstanceKey];
        if (instance) {
            handleInstance(instance);
            return;
        }
        // у нас может быть уже существующий дескриптор, который задан другим инстансом EventeaStatistQueue
        const currentDescriptor = Object.getOwnPropertyDescriptor(window, globalInstanceKey);
        Object.defineProperty(window, globalInstanceKey, {
            set: (value) => {
                var _a;
                (_a = currentDescriptor === null || currentDescriptor === void 0 ? void 0 : currentDescriptor.set) === null || _a === void 0 ? void 0 : _a.call(currentDescriptor, value);
                handleInstance(value);
            },
            configurable: true,
        });
    }
}
exports.EventeaStatistQueue = EventeaStatistQueue;
